import { INITIAL, PENDING, COMPLETED, FAILED } from "engine/modules/constants"
import get from "lodash/get"
import { showToast } from "@infotech/uikit-toasts"
import {
  READ_EVENT_RESOURCES_LIST,
  READ_EVENT_RESOURCES_LIST_SUCCEEDED,
  READ_EVENT_RESOURCES_LIST_FAILED,
  RESET_EVENT_RESOURCES_LIST,
  ADD_EVENT_RESOURCE,
  ADD_EVENT_RESOURCE_SUCCEEDED,
  ADD_EVENT_RESOURCE_FAILED,
  DELETE_EVENT_RESOURCE,
  DELETE_EVENT_RESOURCE_SUCCEEDED,
  DELETE_EVENT_RESOURCE_FAILED,
  READ_EVENT_AVAILABLE_RESOURCES_LIST,
  READ_EVENT_AVAILABLE_RESOURCES_LIST_SUCCEEDED,
  READ_EVENT_AVAILABLE_RESOURCES_LIST_FAILED,
} from "../actions/types"

export const INITIAL_STATE = {
  status: INITIAL,
  data: [],
  available: {
    data: [],
    total: 0,
  },
}

export default function notificationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // read event resources list
    case READ_EVENT_RESOURCES_LIST:
      return {
        ...state,
        status: PENDING,
      }
    case READ_EVENT_RESOURCES_LIST_SUCCEEDED: {
      return {
        ...state,
        status: COMPLETED,
        data: action.response,
      }
    }
    case READ_EVENT_RESOURCES_LIST_FAILED:
      return {
        ...state,
        status: FAILED,
      }

    // reset event resources list
    case RESET_EVENT_RESOURCES_LIST:
      return {
        ...state,
        data: [],
      }

    // read event available resources list
    case READ_EVENT_AVAILABLE_RESOURCES_LIST:
      return {
        ...state,
        status: PENDING,
      }
    case READ_EVENT_AVAILABLE_RESOURCES_LIST_SUCCEEDED: {
      return {
        ...state,
        status: COMPLETED,
        available: {
          data: action.response.data,
          total: +get(action, `response.headers.total-count`),
        },
      }
    }
    case READ_EVENT_AVAILABLE_RESOURCES_LIST_FAILED:
      return {
        ...state,
        status: FAILED,
      }
    // add resources to list
    case ADD_EVENT_RESOURCE:
      return {
        ...state,
        status: PENDING,
      }
    case ADD_EVENT_RESOURCE_SUCCEEDED: {
      const resourceName = get(action, `action.config.resourceData.name`)
      const data = [get(action, `action.config.resourceData`)]
      const stateData = state.data
      showToast({
        type: `success`,
        message: `Ресурс "${resourceName}" успешно добавлен.`,
        hideIn: 5,
      })
      return {
        ...state,
        status: COMPLETED,
        data: data.concat(stateData),
      }
    }
    case ADD_EVENT_RESOURCE_FAILED:
      return {
        ...state,
        status: FAILED,
      }
    // delete resources to list
    case DELETE_EVENT_RESOURCE:
      return {
        ...state,
        status: PENDING,
      }
    case DELETE_EVENT_RESOURCE_SUCCEEDED: {
      const resourceName = get(action, `action.config.resourceName`)
      const removeUuid = get(action, `action.config.resourceUuid`)
      const stateData = state.data
      showToast({
        type: `error`,
        message: `Ресурс "${resourceName}" удален.`,
        hideIn: 5,
      })
      return {
        ...state,
        status: COMPLETED,
        data: stateData.filter(resource => resource.uuid !== removeUuid),
      }
    }
    case DELETE_EVENT_RESOURCE_FAILED:
      return {
        ...state,
        status: FAILED,
      }
    default:
      return state
  }
}
